import { useEffect } from 'react'
import { __OBJECT_STRUCTURE_GetUserProps } from '../../../common/ObjectStructures/sBook';
import { getBookMemberRelationshipProps, getListPrivilegeBook } from '../../../services/sPrivilege/privilege.service';
//Obtener los roles desde API Auth, o definir roles como diccionario en el web. (VALIDAR CON PABLO).
const useGetMessageBookMemberRelationshipProps = (bookId, userName, userProps, setUserProps) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBookMemberRelationshipProps(bookId, userName);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setUserProps(response.data);
                }
                else {
                    setUserProps(__OBJECT_STRUCTURE_GetUserProps(""));
                }
            }
            catch (error) {
                setUserProps(__OBJECT_STRUCTURE_GetUserProps(""));
            }
        }
        
        if (bookId !== null && userName !== null && userProps.username === null) {
            getData()
        }
    }, [bookId, userName, userProps, setUserProps]);
}

const useOfGetListPrivilegeBook = (clientRoleList, setClientRoleList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListPrivilegeBook();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setClientRoleList(response.data);
                }
                else {
                    setClientRoleList([]);
                }
            }
            catch (error) {
                setClientRoleList([]);
            }
        }
        
        if (clientRoleList === null) {
            getData()
        }
    }, [clientRoleList, setClientRoleList]);
}

export {
    useGetMessageBookMemberRelationshipProps,
    useOfGetListPrivilegeBook
}